import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Brazilian CPF validator following Single Responsibility Principle
 */
export class CpfValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Brazilian CPF',
      pattern: /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/,
      length: 11
    });
  }

  validateFormat(id) {
    const cleanId = id.replace(/[.-]/g, '');
    
    // Check length
    const lengthValidation = this.validateLength(cleanId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    const patternValidation = this.validateRegex(
      id,
      this.config.pattern,
      'CPF format must be XXX.XXX.XXX-XX or XXXXXXXXXXX'
    );
    if (!patternValidation.isValid) {
      return patternValidation;
    }

    // Check for known invalid CPFs (all same digits)
    if (/^(\d)\1{10}$/.test(cleanId)) {
      return ValidationResult.invalid('CPF cannot have all identical digits');
    }

    return ValidationResult.valid();
  }

  validateChecksum(id) {
    const cleanId = id.replace(/[.-]/g, '');
    const digits = cleanId.substring(0, 9);
    const [expectedFirst, expectedSecond] = ChecksumCalculator.calculateCpfChecksum(digits);
    
    const actualFirst = parseInt(cleanId[9]);
    const actualSecond = parseInt(cleanId[10]);

    if (expectedFirst !== actualFirst || expectedSecond !== actualSecond) {
      return ValidationResult.invalid('Invalid CPF checksum');
    }

    return ValidationResult.valid('Valid CPF');
  }
}